/**
 *
 * LegalDocumentForm
 *
 */

import React, { useEffect } from 'react';
import { Box, Container, Paper, Stack } from '@mui/material';
import { useLegalDocumentsSlice } from './slice';
import { useDispatch, useSelector } from 'react-redux';
import { selectLegalDocumentsSlice } from './slice/selectors';
import { useHasChanged } from '../../../utils/usePrevious';
import { appActions } from '../App/slice';
import key from 'weak-key';
import { get } from 'lodash';
import { DocumentForm } from './DocumentForm';

export function Edit() {
  const dispatch = useDispatch();
  const { actions } = useLegalDocumentsSlice();

  const { legalDocuments, updateItem } = useSelector(selectLegalDocumentsSlice);

  const load = () => {
    dispatch(actions.loadLegalDocumentsRequest());
  };

  useEffect(() => {
    load();
    return () => {
      // unmount if needed
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateLoadingHasChanged = useHasChanged(updateItem.loading);

  React.useEffect(() => {
    if (updateLoadingHasChanged && !updateItem.loading) {
      load();
      dispatch(appActions.loadRequest());
    }
  });
  /*

   */

  const codes = [
    {
      code: 'nda',
      name: 'Non-Disclosure Agreement',
    },
    {
      code: 'coc',
      name: 'Code of Conduct',
    },
    {
      code: 'rrg',
      name: 'Remote Recording Guidelines',
    },
    {
      code: 'ccp',
      name: 'Child Care Policy',
    },
  ];
  console.log(legalDocuments.data);
  return (
    <>
      <Box>
        <Container maxWidth={'xl'}>
          <Paper sx={{ my: 4, p: 4 }}>
            <Stack spacing={2}>
              {codes.map(code => (
                <DocumentForm
                  onUpdateItem={values =>
                    dispatch(actions.updateItemRequest(values))
                  }
                  key={key(code)}
                  code={code}
                  document={get(legalDocuments, `data[${code.code}]`)}
                />
              ))}
            </Stack>
          </Paper>
        </Container>
      </Box>
    </>
  );
}
